<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Desert King’s Pregnant Bride</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="titlePage" id="tp01"><a id="page03"><h2 class="titlePageTitle"><span class="bold"><span>THE DESERT KING’S PREGNANT BRIDE</span></span></h2><h2 class="titlePageAuthor"><span class="bold"><span>ANNIE WEST</span></span></h2><p class="titlePageText"><span><span class="smallCaps"><span>~ UNEXPECTED BABIES ~</span></span></span></p><p class="titlePageCity"><span><img alt="image" src="Images/logo.jpg"/></span></p></a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// desertkingspregnantbridethe_tp01.vue?83b02422